module.exports = "./assets/images/pic4.jpeg";